<template>
  <div>
    <div class="oficina-tabs">
      <button
        v-for="tab in step.tabs"
        :key="tab.id"
        class="oficina-tab"
        :class="{ active: activeTab === tab.id }"
        @click="updateTab(tab.id)"
      >
        <span :class="getIconClass(tab.icon)"></span> {{ tab.label }}
      </button>
    </div>
    <div class="oficina-tab-content">
      <div v-if="activeTab === 'access'">
        <p class="oficina-slide-text" v-html="`&quot;${currentTab.content.replace(/\n/g, '<br>')}&quot;`"></p>
        <p v-if="currentTab.subtext" class="oficina-slide-subtext">{{ currentTab.subtext }}</p>
        <div v-if="currentTab.whatsappNumber" class="qr-section">
          <div class="qr-container">
            <div class="oficina-qr-code">
              <img :src="qrCodeUrl" alt="QR Code WhatsApp" />
            </div>
            <div class="qr-info">
              <div class="qr-header">
                <p>Suporte eSUS Feedback</p>
                <button type="button" @click="copyWhatsappLink" class="copy-btn" title="Copiar link do WhatsApp">
                  <span class="oficina-icon-copy"></span>
                </button>
              </div>
              <p class="qr-number">{{ formattedWhatsapp }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="activeTab === 'test'">
        <div class="test-section">
          <div class="test-icon">
            <i class="icofont-paper-plane"></i>
          </div>
          <p class="oficina-slide-text">{{ currentTab.content }}</p>
          <button
            type="button"
            class="oficina-checklist-toggle"
            :class="{ checked: isChecked }"
            @click="toggleChecklist"
          >
            <i v-if="isChecked" class="icofont-check-circled"></i>
            <div v-else class="check-circle"></div>
            <span>{{ isChecked ? 'Teste Confirmado!' : 'Aguardando confirmação...' }}</span>
          </button>
          <p v-if="currentTab.action" class="test-action">
            <i class="icofont-monitor"></i> {{ currentTab.action }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="step.tip" class="oficina-slide-tip">
      <i class="icofont-info-circle"></i> {{ step.tip }}
    </div>
  </div>
</template>

<script>
import { getQRCodeUrl, getWhatsappUrl, formatPhoneNumber, copyToClipboard } from '../../utils'

export default {
  name: 'TabbedInteractionSlide',
  props: {
    step: {
      type: Object,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
    activeTabs: {
      type: Object,
      default: () => ({}),
    },
    checklist: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    activeTab() {
      return this.activeTabs.duvidas || 'access'
    },
    currentTab() {
      return this.step.tabs.find((t) => t.id === this.activeTab) || this.step.tabs[0]
    },
    isChecked() {
      return this.checklist[this.currentTab.checklistKey] || false
    },
    qrCodeUrl() {
      if (!this.currentTab.whatsappNumber) return ''
      return getQRCodeUrl(getWhatsappUrl(this.currentTab.whatsappNumber))
    },
    formattedWhatsapp() {
      if (!this.currentTab.whatsappNumber) return 'Não informado'
      return formatPhoneNumber(this.currentTab.whatsappNumber)
    },
  },
  methods: {
    updateTab(tabId) {
      this.$emit('update-tab', 'duvidas', tabId)
    },
    getIconClass(icon) {
      if (icon === 'QrCode') return 'icofont-qr-code'
      if (icon === 'CheckCircle') return 'icofont-check-circled'
      return 'icofont-info-circle'
    },
    toggleChecklist() {
      const key = this.currentTab.checklistKey
      this.$emit('update-checklist', key, !this.isChecked)
    },
    async copyWhatsappLink() {
      if (!this.currentTab.whatsappNumber) return
      const link = getWhatsappUrl(this.currentTab.whatsappNumber)
      const ok = await copyToClipboard(link)
      if (ok && this.$toast) {
        this.$toast.success('Link do WhatsApp copiado!', 'Copiado', {
          position: 'topRight',
        })
      }
    },
  },
  emits: ['update-tab', 'update-checklist'],
}
</script>

<style scoped>
.oficina-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 24px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.oficina-tabs::-webkit-scrollbar {
  height: 6px;
}

.oficina-tabs::-webkit-scrollbar-track {
  background: transparent;
}

.oficina-tabs::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.oficina-tabs::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.oficina-tab {
  padding: 12px 20px;
  border: 2px solid #e2e8f0;
  border-right: none;
  background: white;
  border-radius: 0;
  cursor: pointer;
  font-weight: 600;
  color: #64748b;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  flex-shrink: 0;
}

.oficina-tab:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.oficina-tab:last-child {
  border-right: 2px solid #e2e8f0;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.oficina-tab.active {
  background: #0FAFD7;
  border-color: #0FAFD7;
  color: white;
  z-index: 1;
  position: relative;
}

.oficina-tab.active + .oficina-tab {
  border-left-color: #0FAFD7;
}

.oficina-tab-content {
  min-height: 300px;
}

.oficina-slide-text {
  font-size: 16px;
  line-height: 1.6;
  color: #1e293b;
  margin-bottom: 16px;
}

.oficina-slide-subtext {
  font-size: 14px;
  color: #64748b;
  margin-top: 16px;
  font-style: italic;
}

.qr-section {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
}

.qr-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.oficina-qr-code {
  background: white;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
}

.oficina-qr-code img {
  width: 200px;
  height: 200px;
  display: block;
}

.qr-info {
  margin-top: 20px;
  text-align: center;
}

.qr-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 4px;
}

.qr-header p {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.copy-btn {
  background: transparent;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #64748b;
  cursor: pointer;
  padding: 4px 8px;
  font-size: 14px;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 28px;
  flex-shrink: 0;
}

.copy-btn:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #0FAFD7;
}

.copy-btn:active {
  transform: scale(0.95);
}

.qr-number {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

/* Ícone de copiar (CSS puro) */
.oficina-icon-copy {
  display: inline-block;
  width: 16px;
  height: 16px;
  position: relative;
  flex-shrink: 0;
  color: inherit;
}

.oficina-icon-copy::before {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 10px;
  height: 12px;
  border: 1.5px solid currentColor;
  border-radius: 2px;
  background: white;
  box-sizing: border-box;
}

.oficina-icon-copy::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 12px;
  border: 1.5px solid currentColor;
  border-radius: 2px;
  background: white;
  transform: translate(4px, 4px);
  opacity: 0.7;
  box-sizing: border-box;
}

.test-section {
  text-align: center;
  padding: 24px;
}

.test-icon {
  width: 80px;
  height: 80px;
  background: #eff6ff;
  color: #0FAFD7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  font-size: 40px;
}

.oficina-checklist-toggle {
  margin: 0 auto;
  padding: 20px 32px;
  border-radius: 16px;
  border: 2px solid #e2e8f0;
  background: white;
  color: #64748b;
  font-weight: 700;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
}

.oficina-checklist-toggle.checked {
  border-color: #16a34a;
  background: #dcfce7;
  color: #166534;
}

.check-circle {
  width: 32px;
  height: 32px;
  border: 2px solid currentColor;
  border-radius: 50%;
}

.test-action {
  margin-top: 32px;
  color: #64748b;
  font-style: italic;
}

.oficina-slide-tip {
  background: #eff6ff;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #bfdbfe;
  margin-top: 24px;
  color: #1e40af;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}
</style>
